import { connect } from 'react-redux';
import { getCurrentOnDemandClip, getCurrentStation, getPlaybackMode, playbackModes } from 'store/reducers/player';
import { getIsFavorite } from 'store/reducers/favorites';

import PlayerFavorites from './PlayerFavorites';

import { withAnalytics } from 'analytics';
import { favoriteStationToggle } from 'actions/favoriteStation-actions';
import { isEmpty } from 'util/index';
import { favoriteClipToggle } from 'actions/favoriteClip-actions';

const mapStateToProps = (state) => {
  const isOnDemand = getPlaybackMode(state) === playbackModes.ON_DEMAND_CLIP;
  const station = getCurrentStation(state);
  const onDemandClip = getCurrentOnDemandClip(state);

  let isFavorite = false;
  const item = isOnDemand ? onDemandClip : station;
  if (!isEmpty(item)) {
    isFavorite = getIsFavorite(state, { item });
  }
  return {
    isOnDemand,
    station,
    onDemandClip,
    isVisible: !isEmpty(station) || !isEmpty(onDemandClip),
    isFavorite,
  };
};

const favoriteStationToggleWithAnalytics = withAnalytics(favoriteStationToggle, {
  'player_add-type': 'player',
});

const favoriteClipToggleWithAnalytics = withAnalytics(favoriteClipToggle, {
  'player_add-type': 'player',
});

const mergeProps = (
  { isOnDemand, station, onDemandClip, isFavorite, isVisible },
  { favoriteClipToggle, favoriteStationToggle }
) => ({
  isVisible,
  isFavorite,
  toggleFavorite: () => (isOnDemand ? favoriteClipToggle(onDemandClip) : favoriteStationToggle(station)),
});

export default connect(
  mapStateToProps,
  {
    favoriteClipToggle: favoriteClipToggleWithAnalytics,
    favoriteStationToggle: favoriteStationToggleWithAnalytics,
  },
  mergeProps
)(PlayerFavorites);
